// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import OrderChangeRequestHeader, {
    OrderChangeRequestHeaderPresentationProps,
} from "@store/Library/Components/OrderChangeRequest/OrderChangeRequestHeader";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import React, { FC, useMemo } from "react";
import { css } from "styled-components";

export interface OrderChangeRequestReviewHeaderProps extends WidgetProps {}

export interface OrderChangeRequestReviewHeaderStyles {
    orderChangeRequestHeader?: OrderChangeRequestHeaderPresentationProps;
}

const OrderChangeRequestReviewHeaderStyles: OrderChangeRequestReviewHeaderStyles = {};

const OrderChangeRequestReviewHeader: FC<OrderChangeRequestReviewHeaderProps> = ({ id }) => {
    const { requestSubmitted } = useAppSelector(state => state.greif.pages.orderChange);
    const styles = useMemo(() => {
        if (!requestSubmitted) {
            return OrderChangeRequestReviewHeaderStyles;
        }

        return mergeProps<OrderChangeRequestReviewHeaderStyles>(OrderChangeRequestReviewHeaderStyles, {
            orderChangeRequestHeader: {
                extendedStyles: {
                    orderHeader: {
                        extendedStyles: {
                            heading: {
                                extendedStyles: {
                                    title: {
                                        css: css`
                                            display: none;
                                        `,
                                    },
                                },
                            },
                        },
                    },
                },
            },
        });
    }, [requestSubmitted]);

    return (
        <OrderChangeRequestHeader {...styles.orderChangeRequestHeader} contentId={id} step={requestSubmitted ? 3 : 2} />
    );
};

const widgetModule: WidgetModule = {
    component: OrderChangeRequestReviewHeader,
    definition: {
        group: constants.widgetGroup.orderChangeRequestReview,
        displayName: "Order Change Request Review Header",
        allowedContexts: [constants.pageType.orderChangeRequestReview],
    },
};

export default widgetModule;
